module.exports = __webpack_public_path__ + "img/retailMall-1.2e3905c4.png";